import React, { useState, useEffect, useContext } from 'react';
import { distitoMateraAPI, apiURL } from '../../Util/apiURL';
import AuthContext from '../../store/auth-context';
import { useHistory, useLocation } from 'react-router';

import {
  createNotaCreditoProveedorActions,
  insertNotaCreditoProveedor,
} from '../../store/crearNotaCreditoProveedor-slice';
import { useSelector, useDispatch } from 'react-redux';

import { CardButton } from '../SharedUi/UpdateCardUI';
import SelectHelper from '../TailwindUI/SelectHelper';
import SelectDate from '../SharedUi/SelectDate';
import { InputCornerHint } from '../SharedUi/Inputs';
import SuccesAlert from '../SuccesAlert/SuccesAlert';

const CreateNotaCreditoFromCpp = props => {
  const authCtx = useContext(AuthContext);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    let firstTime = 0;
    if (firstTime === 0 && props.divisa.id === 1) {
      let payload = {
        reduxStateTree: 'divisa',
        valuesToFilter: [props?.divisa],
        selectedValue: props?.divisa?.id,
      };

      dispatch(createNotaCreditoProveedorActions.asign(payload));
    }
    firstTime++;
  }, []);

  //#region Redux Selectors--------------------------------->

  //   const monto = useSelector((state) => state.createNotaCreditoProveedor.monto);
  const fecha = useSelector(state => state.createNotaCreditoProveedor.fecha);

  const createNotaCreditoProveedor = useSelector(state => state.createNotaCreditoProveedor);

  const observaciones = useSelector(state => state.createNotaCreditoProveedor.observaciones);

  //#endregion  Redux Selectors <---------------------------------
  //#region  DiableSumbit Button

  let disableSubmit = true;

  if (createNotaCreditoProveedor?.monto && fecha && createNotaCreditoProveedor?.divisa?.id) {
    disableSubmit = false;
  }

  //#endregion

  //#region Input Groups--------------------------------->
  const form_datos = [
    {
      parentName: null,
      property: 'observaciones',
      type: 'text',
      foreignKey: false,
      selector: observaciones,
      selectorName: 'observaciones',
    },
  ];

  //#endregion Input Groups <---------------------------------

  //#region Function Handlers--------------------------------->

  const handleAsingDivisa = e => {
    dispatch(createNotaCreditoProveedorActions.asign({ ...e }));
    dispatch(createNotaCreditoProveedorActions.resetMonto());
  };

  const handleCreateNC = () => {
    console.log('create  pago proveedor ');
    let request = {
      cuenta_por_pagar_id: props.cpp?.id,
      divisa_id: createNotaCreditoProveedor.divisa?.id,
      folio: createNotaCreditoProveedor.folio,
      monto: createNotaCreditoProveedor.monto.toFixed(2),
      observaciones: createNotaCreditoProveedor.observaciones,
      fecha: createNotaCreditoProveedor.fecha,
      tipo_de_cambio: createNotaCreditoProveedor?.tipoDeCambio?.toFixed(4),
      proveedor_id: props.cpp?.proveedorId,
    };
    console.log(request);
    dispatch(
      insertNotaCreditoProveedor({
        request,
      }),
    );
    // props.onConfirm();
  };

  const handleDate = e => {
    dispatch(
      createNotaCreditoProveedorActions.change({
        field: 'fecha',
        value: e.target.value,
      }),
    );
  };

  const handleMonto = e => {
    const divisaPeso = props.divisa?.id === 1;
    const divisaDolar = props.divisa?.id === 2;
    const montoValue = Number(e.target.value);
    const montoYTipoDeCambioValue =
      Number(e.target.value) / createNotaCreditoProveedor?.tipoDeCambio;
    const sumaPagosYnotaYMonto = montoValue + props.totalPagosYNotas;
    const sumaPagosYnotaYMontoYtipoDeCambio = montoYTipoDeCambioValue + props.totalPagosYNotas;
    const condition1 = props.totalPagosYNotas === 0 && montoValue <= props.totalCpp;
    const condition2 = sumaPagosYnotaYMonto <= props.totalCpp;
    const condition1TipoDeCambio =
      props.totalPagosYNotas === 0 && montoYTipoDeCambioValue <= props.totalCpp;

    console.log('props.totalCpp->>>' + props.totalCpp);
    console.log('sumaPagosYnotaYMontoYtipoDeCambio->>>' + sumaPagosYnotaYMontoYtipoDeCambio);

    console.log('Restante->>>' + (props.totalCpp - sumaPagosYnotaYMontoYtipoDeCambio));
    const condition2TipoDeCambio = sumaPagosYnotaYMontoYtipoDeCambio <= props.totalCpp;
    const dispatchMonto = () => {
      dispatch(
        createNotaCreditoProveedorActions.change({
          field: 'monto',
          value: e.target.value,
        }),
      );
      return;
    };

    if (e.target.value > 0) {
      console.log('etarget +1');
      if (divisaPeso || (divisaDolar && createNotaCreditoProveedor.divisa.id === 2)) {
        console.log('divisaPeso || if (divisaPeso ||createNotaCreditoProveedor.divisa.id === 2) ');
        if (condition1 || condition2) {
          console.log('(condition1 || condition2) ');
          dispatchMonto();
          return;
        }
        return;
      }
      if (divisaDolar && createNotaCreditoProveedor.divisa.id === 1) {
        console.log('divisaPeso || if (divisaPeso ||createNotaCreditoProveedor.divisa.id === 1) ');
        if (condition1TipoDeCambio || condition2TipoDeCambio) {
          console.log('(condition1TipoDeCambio || condition2TipoDeCambio) ');
          dispatchMonto();

          return;
        }
        return;
      }
      return;
    }
  };
  //#endregion Function Handler <---------------------------------

  return (
    <div className="flex flex-col">
      {/* {JSON.stringify(createNotaCreditoProveedor)} */}

      <>
        <div className="mt-4" />
        <SelectDate reduxStateTree={'fecha'} action={handleDate}>
          <InputCornerHint
            value={createNotaCreditoProveedor?.fechaDisplay}
            disabled
            label={'Fecha'}
          />
        </SelectDate>
        <div className="mt-1" />
        <InputCornerHint
          label={'Folio'}
          type={'text'}
          value={createNotaCreditoProveedor.folio}
          onChange={e => {
            dispatch(
              createNotaCreditoProveedorActions.change({
                value: e.target.value,
                field: 'folio',
              }),
            );
          }}
        />
        <div className="mt-1" />
        {/* <InputCornerHint
          label={'Motivo'}
          type={'text'}
          value={createNotaCreditoProveedor.motivo}
          onChange={(e) => {
            dispatch(
              createNotaCreditoProveedorActions.change({
                value: e.target.value,
                field: 'motivo',
              })
            );
          }}
        /> */}

        {props?.divisa?.id === 2 ? (
          <SelectHelper
            //UI
            label={'Divisa'}
            inputLabel={'SeleccionarDivisa'}
            //URL
            fetchUrl={'divisas'}
            //Redux
            asignTree={'divisa'}
            removeTree={'divisa'}
            valueToAsignSelector={createNotaCreditoProveedor.divisa}
            // asignedListString={'relationsProductos'}

            //Select Options
            nameOfPropertyToAsign={'nombre'}
            //Function Handlers
            handleSelect={handleAsingDivisa}
          />
        ) : (
          <InputCornerHint
            label={'Divisa'}
            type={'text'}
            value={createNotaCreditoProveedor?.divisa?.nombre}
            disbaled
          />
        )}

        <div className="mt-1" />
        {props?.divisa?.id === 2 && createNotaCreditoProveedor?.divisa?.nombre === 'MXN' && (
          <InputCornerHint
            label={'Tipo de Cambio'}
            type={'number'}
            value={createNotaCreditoProveedor.tipoDeCambio}
            onChange={e => {
              dispatch(
                createNotaCreditoProveedorActions.change({
                  value: e.target.value,
                  field: 'tipoDeCambio',
                }),
              );
            }}
          />
        )}

        <div className="mt-6" />
        {createNotaCreditoProveedor.divisa?.id && (
          <InputCornerHint
            label={'Monto'}
            type={'number'}
            value={createNotaCreditoProveedor?.monto}
            onChange={handleMonto}
          >
            <button
              onClick={() => {
                console.log('dispatch saldo pendiente');
                const divisaDolar = props?.divisa?.id === 2;
                const divisaPeso = props?.divisa?.id === 1;

                const restante = Number(props.totalCpp) - Number(props.totalPagosYNotas);
                const restanteContipoDeCambio = restante * createNotaCreditoProveedor?.tipoDeCambio;

                if (divisaDolar) {
                  dispatch(
                    createNotaCreditoProveedorActions.change({
                      field: 'monto',
                      value:
                        props?.divisa?.id === 2 &&
                        createNotaCreditoProveedor?.divisa?.nombre === 'MXN'
                          ? restanteContipoDeCambio.toFixed(2)
                          : restante.toFixed(2),
                    }),
                  );
                }
                if (divisaPeso) {
                  dispatch(
                    createNotaCreditoProveedorActions.change({
                      field: 'monto',
                      value: restante.toFixed(2),
                    }),
                  );
                }
              }}
            >
              <span className="px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                Saldo Pendiente
              </span>
            </button>
          </InputCornerHint>
        )}

        <div className="mt-2" />
        <InputCornerHint
          label={'Observaciones'}
          type={'text'}
          value={createNotaCreditoProveedor?.observaciones}
          onChange={e => {
            dispatch(
              createNotaCreditoProveedorActions.change({
                value: e.target.value,
                field: 'observaciones',
              }),
            );
          }}
        />
      </>

      {createNotaCreditoProveedor.closeModal ? (
        <div className="mt-4">
          <SuccesAlert
            message={'Tu Pago se registro con éxito'}
            onClick={() => {
              props.onConfirm();
              dispatch(createNotaCreditoProveedorActions.resetCloseModal());
            }}
          />
        </div>
      ) : (
        <CardButton disabled={disableSubmit} onClick={handleCreateNC}>
          Registrar Nota de Credito
        </CardButton>
      )}
    </div>
  );
};
export default CreateNotaCreditoFromCpp;
